// extracted by mini-css-extract-plugin
export default {"texte_about_section":"AboutSection_texte_about_section__hbPqB","ranger":"AboutSection_ranger__0Io+Q","col":"AboutSection_col__bo1P-"};